import React from 'react';

import { ToastContainer } from 'react-toastify';

import { useAuth } from '@components/utilComponents/AuthProvider';

import type { AlertContainerProperties } from './AlertContainer.types';

export const AlertContainer: React.FC<AlertContainerProperties> = ({
  position = 'top-left',
  autoClose = false,
  hideProgressBar = false,
  pauseOnHover = true,
  stacked = true,
  containerId,
  icon = false,
  limit,
  closeOnClick = true,
  onClick,
  closeButton = false,
  draggableDirection = 'x',
  draggable = 'touch',
  draggablePercent = 80,
  role = 'alert',
  pauseOnFocusLoss = true,
  newestOnTop,
}) => {
  const user = useAuth();

  return (
    <ToastContainer
      position={position}
      autoClose={autoClose}
      hideProgressBar={hideProgressBar}
      theme={user?.settings?.theme || 'light'}
      pauseOnHover={pauseOnHover}
      stacked={stacked}
      containerId={containerId}
      closeButton={closeButton}
      closeOnClick={closeOnClick}
      onClick={onClick}
      draggable={draggable}
      draggablePercent={draggablePercent}
      role={role}
      draggableDirection={draggableDirection}
      icon={icon}
      newestOnTop={newestOnTop}
      limit={limit}
      pauseOnFocusLoss={pauseOnFocusLoss}
    />
  );
};
